<template>
<div class="lg:flex">
    <div class="lg:w-1/2 w-auto px-4 my-auto">
        <!-- <label for="Coupon">Hast du einen Gutschein?</label> -->
        <!-- <div class="relative flex w-full flex-wrap items-stretch mb-3">
          <span class="z-10 h-full leading-snug font-normal absolute text-center text-gray-600 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i class="fas fa-gift"></i>
          </span>
          <input v-on:keyup.13="get_total_price()" @blur="get_total_price()" type="text" placeholder="Gutschein entdecken"
          class="px-3 py-3 placeholder-gray-600 text-gray-600 relative bg-white bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full pl-10"
          v-model="coupon" id="coupon" name="coupon" v-bind:class="[couponState]"
          />
         
        </div> -->
      <h1 class="text-gray-900 pt-6 pb-2 text-xl">Zahlungs methoden</h1>
      <div class="py-4 border-t">
        <label class="inline-flex items-center">
          <input @click="get_total_price()" type="radio" v-model="payment" value="Stripe" class="form-radio" name="radio" />
          <span class="ml-2 text-gray-900 font-semibold">Kreditkarte</span>
          <span class="px-1">
            <img class="w-10" src="@/assets/images/Visa.jpg" alt="visa" />
          </span>
          <span class="px-1">
            <img class="w-10" src="@/assets/images/Mastercard.jpg" alt="mastercard" />
          </span>
        </label>
      </div>
      <div class="border-b"></div>
      <div v-show="payment === 'Stripe'" class="py-6">
        <stripe-elements
          ref="elementsRef"
          :pk="publishableKey"
          :amount="amount"
          locale="en"
          @token="tokenCreated"
          @loading="loading = $event"
        ></stripe-elements>
        <button
          @click="$refs.elementsRef.submit()"
          color="#42b883"
          dark
          large
          class="bg-teal-400 px-3 py-1 font-semibold text-white rounded hover:bg-white w-full hover:text-teal-400 shadow"
        >Pay {{ total | formatNumber }}</button>
      </div>
      <div class="py-4">
        <label class="inline-flex items-center">
          <input @click="get_total_price()" type="radio" v-model="payment" value="Paypal" class="form-radio" name="radio" />
          <span class="ml-2 text-gray-900 font-semibold">PayPal</span>
          <span class="px-1">
            <img class="w-16" src="@/assets/images/Paypal.jpg" alt="paypal" />
          </span>
        </label>
      </div>
      <div v-show="payment === 'Paypal'" class="py-6">
        <div ref="paypal"></div>
      </div>
      
      <div>
        <p class="text-teal-400 font-semibold text-md py-3 shadow-md mx-auto">{{ msg }}</p>
      </div>
    </div>
    <OrderReview :cartItems="cartItems" :finalModel="finalModel"  :Propcoupon ="this.total_price" :CouponUsed="this.CouponUsed"/>
</div>
</template>

<script>
import axios from "axios";
import OrderReview from './OrderReview';
import { StripeElements } from "vue-stripe-checkout";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    StripeElements,
    OrderReview
  },
  props: {
    cartItems: Array,
    finalModel: Object
  },
  data() {
    return {
      total_price: 0,
      step: 3,
      payment: "",
      loaded: false,
      paidFor: false,
      msg: "",
      product: {
        price: 0.1,
        description: "PAYMENT FROM HOMEFACE sap",
        img: "test",
      },
      loading: false,
      amount: 0,
      publishableKey: "pk_live_uFphP6jyECoSobBiZmhsiZ3m",
      //pk_test_51JY7mpFNGK34XLtH4wmpXfb88Ot5Y0tMNNErYA1gAmc41EG7fsAOf5rN5MiaQiTZQMtidjnF90X8jdIo1AyumcHR00bUqDFCky
      // publishableKey: "pk_test_51JY7mpFNGK34XLtH4wmpXfb88Ot5Y0tMNNErYA1gAmc41EG7fsAOf5rN5MiaQiTZQMtidjnF90X8jdIo1AyumcHR00bUqDFCky",
       // sk_test_51HLNTpKexNmuZ02rLZHKoJ5vIxr8zeI2iEtKs3r2p65u3VNmNFGDtj1grorL6JyCAv80EnK97KIhHxJ0EofnNPk000M90vvsMK
    // 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
      // secretKey:
     // !!! GJITHMONE KONTROLLO QELSIN PRIVAT - MUND TE NDRYSHOJ !!!
      //   "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",
        secretKey:
        "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",
      token: null,
      charge: null,
      dialog: false,
      order_id: '',
      coupon: '',
      couponState: '',
      CouponUsed: false,
      couponText: ''
    };
  },
  validations: {
    payment: {
      required,
    },
    form: ["payment"],
  },
  computed: {
    getCartItems() {
      return this.cartItems;
    },
    total() {
      return this.total_price;
    },
  },
  mounted: function () {
    const script = document.createElement("script");

    // use this for testing
    // script.src = "https://www.paypal.com/sdk/js?currency=EUR&client-id=AaOyLCLMdhHiQMm6d5g4MZFHw9ObyyQB0BxL8PmsfmN2XR__FvfeH0PVtGvrfZiOOejbavdczJTLPzKU";

    script.src =
     "https://www.paypal.com/sdk/js?currency=EUR&client-id=ASmVLPTZMUV-_9o1dkA-k5ixCSJ1Fc_aqGGSFVa42FndRodMZirx2-f0QOR6nGr1ne3E530Vkw20cQnX";

    script.addEventListener("load", this.setLoaded);
    document.body.appendChild(script);
  },
  created() {
    // console.log(this.tokenCreated(this.token));
  },
  methods: {
    get_total_price() {
      axios
        .post(`${process.env.VUE_APP_API}/payment`, {
          items: this.cartItems,
          coupon: this.coupon
          
        })
        .then((response) => {
                this.total_price = response.data.total_price;
                this.couponState = this.total_price;
                console.log(this.cartItems)
                console.log(this.total_price)
                // console.log(response.data.help);
                console.log(response.data);
                this.couponState = '';
                this.couponText = '';
                this.CouponUsed = false;
                if(response.data.couponExist)
                {                  
                  if(response.data.couponExist == 'notexist')
                  {
                    this.couponState = ' border border-red-500';
                    this.CouponUsed = false;
                  }
                  else if(response.data.couponExist == 'exist')
                  {
                    this.couponState = ' border border-green-500';  
                    this.CouponUsed = true;
                    this.couponText = response.data.couponText
                  }
                }
                })
    },
    validate() {
      if (this.paidFor) {
        this.$v.form.$touch();
        var isValid = !this.$v.form.$invalid;
        this.$emit("on-validate", this.$data, isValid);
        return isValid;
      } else {
        return false;
      }
    },
    setLoaded: function () {
      this.loaded = true;
      window.paypal
        .Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  description: this.order_number,
                  amount: {
                    currency_code: "EUR",
                    value: Math.round(this.total * 100) / 100,
                  },
                },
              ],
            });
          },
          onApprove: async (data, actions) => {
            const order = await actions.order.capture();
            this.data;
            this.paidFor = true;
            this.successMsg = "You have successfully paid via PayPal!";
            console.log(order);
            
            axios.defaults.headers.common["Authorization"] =
              "Bearer " + localStorage.getItem("access_token");

            let billAddress = {
              address_1: this.finalModel.billing_address_1,
              address_2: this.finalModel.billing_address_2,
              city: this.finalModel.billing_city,
              state: this.finalModel.billing_state,
              zip: this.finalModel.billing_zip,
              country: this.finalModel.billing_country,
            };

            let shipAddress = {
              address_1: this.finalModel.address_1,
              address_2: this.finalModel.address_2,
              delivery_date: this.finalModel.delivery_date,
              city: this.finalModel.city,
              state: this.finalModel.state,
              zip: this.finalModel.zip,
              country: this.finalModel.country,
            };

            // console.log(billAddress);
            // console.log(shipAddress);

            // console.log(this.cartItems);

            if(this.cartItems.length > 0) {
              axios
                .post(`${process.env.VUE_APP_API}/order`, {
                  vendor_id: 1,
                  warehouse_id: 1,
                  shop_id: 1,
                  order_number: this.order_number,
                  amount: this.total,
                  shipping_address: JSON.stringify(shipAddress),
                  billing_address: JSON.stringify(billAddress),
                  items: this.cartItems,
                  couponText: this.couponText
                })
                .then((response) => {
                 this.order_id = response.data;
                  this.$notify({
                    group: "address",
                    title: "Bestellung",
                    text: "Bestellung wurde aufgegeben",
                  });
                  this.$router.push({ name: "thankyou", query: {id: this.order_id}});
                  localStorage.removeItem("cart");
                  location.reload();
                  this.$store.mutations.removeCart;
                })
                .catch((error) => console.log(error));
            }
          },
          onError: (err) => {
            console.log(err);
          },
        })
        .render(this.$refs.paypal);
    },
    submit() {
      this.$refs.elementsRef.submit();
    },
    tokenCreated(token) {
      console.warn(token);
      this.token = token;
      this.charge = {
        token: this.token,
        source: token.card,
        amount: this.total,
        description: this.description,
      };
      this.sendTokenToServer(this.charge);
    },
    sendTokenToServer() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      // console.log(localStorage.getItem("access_token"));
      axios
        .post(`${process.env.VUE_APP_API}/charge`, this.charge)
        .then((response) => {
          if (response.status == 200) {
            this.paidFor = true;
            this.msg = "You have successfully paid via Stripe!";
            
            axios.defaults.headers.common["Authorization"] =
              "Bearer " + localStorage.getItem("access_token");

            let billAddress = {
              address_1: this.finalModel.billing_address_1,
              address_2: this.finalModel.billing_address_2,
              city: this.finalModel.billing_city,
              state: this.finalModel.billing_state,
              zip: this.finalModel.billing_zip,
              country: this.finalModel.billing_country,
            };

            let shipAddress = {
              address_1: this.finalModel.address_1,
              address_2: this.finalModel.address_2,
              delivery_date: this.finalModel.delivery_date,
              city: this.finalModel.city,
              state: this.finalModel.state,
              zip: this.finalModel.zip,
              country: this.finalModel.country,
            };

            if(this.cartItems.length > 0) {
              axios
                .post(`${process.env.VUE_APP_API}/order`, {
                  vendor_id: 1,
                  warehouse_id: 1,
                  shop_id: 1,
                  order_number: this.order_number,
                  amount: this.total,
                  shipping_address: JSON.stringify(shipAddress),
                  billing_address: JSON.stringify(billAddress),
                  items: this.cartItems,
                  couponText: this.couponText
                  
                })
                .then((response ) => {
                  // console.log(response)
                  this.order_id = response.data;
                  this.$notify({
                    group: "address",
                    title: "Bestellung",
                    text: "Bestellung wurde aufgegeben",
                  });
                  this.$router.push({ name: "thankyou", query: {id: this.order_id}});
                  localStorage.removeItem("cart");
                  location.reload();
                  this.$store.mutations.removeCart;
                })
                .catch((error) => console.log(error));
            }
          }
        })
        .catch(error => {
          this.msg = error.response.data.message;
        });
    },
  },
};
</script>

<style>
</style>